import { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { PLAYBOOK_CATEGORY_LABELS } from "../../../constants/automapOperationsPlaybookConstants";
import { fetchPlaybookHub, searchPlaybook } from "../../../services/automapOperationsPlaybookApi";
import { PlaybookShell } from "./AdminPlaybookShared";

export default function AdminPlaybookHubPage() {
  const [payload, setPayload] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [query, setQuery] = useState("");
  const [searchResults, setSearchResults] = useState(null);
  const [searching, setSearching] = useState(false);

  useEffect(() => {
    fetchPlaybookHub()
      .then(setPayload)
      .catch((err) => setError(err.message || "Error al cargar playbook."))
      .finally(() => setLoading(false));
  }, []);

  const handleSearch = async (e) => {
    e.preventDefault();
    if (!query.trim()) {
      setSearchResults(null);
      return;
    }
    setSearching(true);
    try {
      const results = await searchPlaybook(query.trim());
      setSearchResults(results);
    } catch (err) {
      setError(err.message || "Error en búsqueda.");
    } finally {
      setSearching(false);
    }
  };

  const categoryCards = useMemo(() => payload?.categories || [], [payload]);

  return (
    <PlaybookShell
      active="hub"
      title="Operations Playbook"
      description="Procedimientos internos para operar AutoMapa después del launch."
      viewEvent="operations_playbook_viewed"
    >
      {payload?.roleFilterNote ? <p className="dealer-state-box muted">{payload.roleFilterNote}</p> : null}

      <form className="admin-playbook__search dealer-state-box" onSubmit={handleSearch}>
        <label>
          Buscar en playbook
          <input
            type="search"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            placeholder="dealer onboarding, stale, WhatsApp…"
          />
        </label>
        <button type="submit" className="dealer-portal-btn" disabled={searching}>
          {searching ? "Buscando…" : "Buscar"}
        </button>
      </form>

      {searchResults ? (
        <section className="dealer-state-box">
          <h3>Resultados: “{searchResults.query}”</h3>
          {!searchResults.sections?.length && !searchResults.templates?.length && !searchResults.checklists?.length ? (
            <p className="muted">Sin resultados.</p>
          ) : (
            <>
              {searchResults.sections?.length ? (
                <>
                  <h4>Secciones</h4>
                  <ul>
                    {searchResults.sections.map((s) => (
                      <li key={s.slug}>
                        <Link to={`/admin/playbook/${s.slug}`}>{s.title}</Link>
                      </li>
                    ))}
                  </ul>
                </>
              ) : null}
              {searchResults.templates?.length ? (
                <>
                  <h4>Plantillas</h4>
                  <ul>
                    {searchResults.templates.map((t) => (
                      <li key={t.id}>{t.title}</li>
                    ))}
                  </ul>
                </>
              ) : null}
              {searchResults.checklists?.length ? (
                <>
                  <h4>Checklists</h4>
                  <ul>
                    {searchResults.checklists.map((c) => (
                      <li key={c.id}>
                        <Link to={`/admin/playbook/checklists?checklist=${c.id}`}>{c.title}</Link>
                      </li>
                    ))}
                  </ul>
                </>
              ) : null}
            </>
          )}
          <button type="button" className="dealer-portal-btn" onClick={() => setSearchResults(null)}>
            Limpiar búsqueda
          </button>
        </section>
      ) : null}

      {loading ? <p className="dealer-state-box">Cargando…</p> : null}
      {error ? <p className="dealer-state-box">{error}</p> : null}

      {!loading && payload ? (
        <>
          <section>
            <h3 className="admin-playbook__section-title">Categorías</h3>
            <div className="admin-playbook__category-grid">
              {categoryCards.map((card) => (
                <Link key={card.category} to={card.href} className="dealer-state-box admin-playbook__category-card">
                  <strong>{card.label}</strong>
                  <p className="muted">{PLAYBOOK_CATEGORY_LABELS[card.category] || card.category}</p>
                  {card.section?.summary ? <small>{card.section.summary.slice(0, 100)}…</small> : null}
                </Link>
              ))}
            </div>
          </section>

          <section className="dealer-state-box">
            <h3>Workflows diarios prioritarios</h3>
            <ul className="dashboard-checklist">
              {(payload.dailyWorkflows || []).map((wf) => (
                <li key={wf.slug}>
                  <Link to={`/admin/playbook/${wf.slug}`}>{wf.label}</Link>
                  {" · "}
                  <Link to={`/admin/playbook/checklists?checklist=${wf.checklistId}`}>Checklist</Link>
                </li>
              ))}
            </ul>
          </section>

          <section className="dealer-state-box">
            <h3>Checklists operativos</h3>
            <ul className="dashboard-checklist">
              {(payload.hubChecklists || []).map((item) => (
                <li key={item.checklistId}>
                  <Link to={item.href}>{item.label}</Link>
                </li>
              ))}
            </ul>
          </section>

          <section className="dealer-state-box">
            <h3>Actualizado recientemente</h3>
            <ul>
              {(payload.recentlyUpdated || []).map((s) => (
                <li key={s.slug}>
                  <Link to={`/admin/playbook/${s.slug}`}>{s.title}</Link>
                  <span className="muted"> · {s.updatedAt?.slice(0, 10)}</span>
                </li>
              ))}
            </ul>
          </section>
        </>
      ) : null}
    </PlaybookShell>
  );
}
